interface ElementSpec {
  tag: string;
  className?: string;
  text?: string;
  attrs?: Record<string, string>;
}

/**
 * The only way renderers build DOM nodes — text always goes through
 * `textContent`, attributes through `setAttribute`, never innerHTML. This
 * keeps "never inject model-generated HTML" a structural guarantee rather
 * than something each renderer has to remember to do correctly.
 */
export function el(spec: ElementSpec): HTMLElement {
  const node = document.createElement(spec.tag);
  if (spec.className) node.className = spec.className;
  if (spec.text !== undefined) node.textContent = spec.text;
  if (spec.attrs) {
    for (const [key, value] of Object.entries(spec.attrs)) {
      node.setAttribute(key, value);
    }
  }
  return node;
}
